export const environment = {
    production: false,
    apiURL: 'https://api-dev.day1cloud.com/api',
    // apiURL: 'http://localhost:4400/api',
    oauth: {
        clientId: 'ext_sp_delegated_admin',
        issuer: 'https://risk-detection-router-api-dev-lawlr1.rajrd4-2.usa-e1.cloudhub.io/ext/oauth2/'
    }    
}